/*
 * Avisos do navegador do "Calendário Marketing Tarefas" - a parte LEVE (sem o motor): o que a pessoa ligou neste navegador e a
 * permissão do navegador. Pedido do Rafael em 03/11/2026 ("esquema de notificação de navegador para ela", "para toda a tela tem que
 * ter notificação"). Quem liga é a própria pessoa, na tela do calendário (botão Avisos); quem avisa é AvisosCalendarioMkt (montado no
 * App, então vale em qualquer página do Central). Fica no localStorage deste navegador: { ativo, pessoa, anoInicial }.
 */
export const CHAVE = 'cmt.avisos';
export const EVENTO = 'cmt:avisos';
export const URL_TELA = '/personalizados/calendario-marketing-tarefas';

const temAviso = () => typeof window !== 'undefined' && 'Notification' in window && window.isSecureContext !== false;

export function leAvisos() {
    try {
        const o = JSON.parse(window.localStorage.getItem(CHAVE) || 'null');
        return o && typeof o === 'object' ? o : null;
    } catch (_) {
        return null;
    }
}

// grava e avisa quem está ouvindo nesta aba (o evento "storage" só chega nas OUTRAS abas)
export function gravaAvisos(cfg) {
    try { window.localStorage.setItem(CHAVE, JSON.stringify(cfg)); } catch (_) { /* sem armazenamento: não liga */ }
    window.dispatchEvent(new Event(EVENTO));
}

// 'sem' (navegador sem aviso ou página sem https) | 'bloqueado' (a pessoa negou) | 'ligado' | 'desligado'
export function estadoAvisos() {
    if (!temAviso()) return 'sem';
    if (window.Notification.permission === 'denied') return 'bloqueado';
    const c = leAvisos();
    return c && c.ativo && window.Notification.permission === 'granted' ? 'ligado' : 'desligado';
}

// pede a permissão (tem de vir de um clique da pessoa) -> 'granted' | 'denied' | 'default' | 'sem'
export async function pedePermissao() {
    if (!temAviso()) return 'sem';
    if (window.Notification.permission === 'granted') return 'granted';
    try { return await window.Notification.requestPermission(); } catch (_) { return 'default'; }
}

// mostra um aviso; o clique leva para a tela do calendário. Em celular o construtor pode não existir (exige service worker): ignora.
export function mostraAviso(titulo, { texto = '', tag = '', url = URL_TELA } = {}) {
    if (!temAviso() || window.Notification.permission !== 'granted') return null;
    try {
        const n = new window.Notification(titulo, { body: texto, tag: tag || undefined, icon: '/favicon-32.png', lang: 'pt-BR' });
        n.onclick = () => {
            try { window.focus(); } catch (_) { /* nada */ }
            if (!window.location.pathname.startsWith(url)) window.location.assign(url);
            n.close();
        };
        return n;
    } catch (_) {
        return null;
    }
}

// o que a tela (folha.js) recebe para o botão Avisos
export const AVISOS = { le: leAvisos, grava: gravaAvisos, estado: estadoAvisos, pede: pedePermissao, mostra: mostraAviso };
